$(document).ready(function () {
  $("#check-form").submit(async (e) => {
    e.preventDefault();

    const submitBtn = e.target.querySelector('[type="submit"]')
    submitBtn.disabled = true;

    let payload = {};
    var formdata = new FormData();
    for (let key of e.target.elements) {
      if (key.getAttribute("name")) {
        if(key.selectedOptions) {
          if (key.selectedOptions[0].innerText == "Please Select") continue;
            formdata.append(
            key.getAttribute("name"),
            key.selectedOptions[0].innerText
          );         
        } else formdata.append(key.getAttribute("name"), key.value);
        
      }
    }

  
    const promise = await fetch(
      "https://hooks.zapier.com/hooks/catch/16755338/259o9wt/",
      {
        method: "POST",
        body: formdata,
        redirect: "follow"
      }
    );
    const response = await promise.json();
    if(response && response.status == 'success'){
        console.log(`response`,response);
        $('.status-form-success').show();
        submitBtn.style.display = "none"
        setTimeout(() => {
          window.location.href = "/";
        },4000)
    }
  
  });
});
